
export const distributions = [
    { name: 'Limited', text: 'Up to 1,500 copies & 250,000 audio streams' },
    { name: 'Unlimited', text: 'UNLIMITED copies and audio streams' },
];